"use client";

import React, { CSSProperties } from 'react';
import { useRouter } from 'next/navigation';

const ErrorPage = () => {
	const router = useRouter();

	const handleRetry = () => {
		router.refresh();
	};

	return (
		<div style={styles.container}>
			<h1 style={styles.heading}>Алдаа гарлаа</h1>
			<p style={styles.message}>Системд ямар нэгэн алдаа гарсан тул та дараа дахин оролдононо уу.</p>
			<button style={styles.button} onClick={handleRetry}>Дахин оролдох</button>
			<button style={styles.button} onClick={() => router.push('/')}>Нүүр хуудас</button>
		</div>
	);
};

const styles: { [key: string]: CSSProperties } = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100vh',
		textAlign: 'center',
		padding: '0 20px',
	},
	heading: {
		fontSize: '2rem',
		marginBottom: '1rem',
	},
	message: {
		fontSize: '1rem',
		marginBottom: '1.5rem',
	},
	button: {
		padding: '10px 20px',
		fontSize: '1rem',
		margin: '0.5rem',
		cursor: 'pointer',
	},
};

export default ErrorPage;